import { useCloudStatus } from "../../hooks/use-cloud-status";

import { Fragment, PropsWithChildren, useEffect } from "react";

/**
 * Timing component to set the percieved provisioning start timer.
 */
export const PerceivedProvisioningStartTimer = ({
    children
}: PropsWithChildren) => {
    const { startPerceivedProvisioningTimer } = useCloudStatus();

    useEffect(() => {
        startPerceivedProvisioningTimer();
    }, []);

    return <Fragment>{children}</Fragment>;
};
